import React from 'react';

const AccountingFinance = () => {
  return (
    <div>
      AccountingFinance
      AccountingFinance
    </div>
  );
}

export default AccountingFinance;
